import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=73531ddc&scoped=true"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"
import style0 from "./ReturnPolicy.vue?vue&type=style&index=0&id=73531ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73531ddc",
  null
  
)

export default component.exports